<template>
    <div class="invoice_form_content">
        <el-row v-if="isReadonly && showRemark">
            <el-col :span="12">
                <el-form inline="inline" label-position="left" label-width="70px">
                    <el-form-item :label="remarkLabel" class="remark_detail">
                        <el-input
                                :readonly="!remarkStatus"
                                placeholder=" "
                                v-model="editForm[invoiceForm.remark.FiledKey]">
                            <el-button slot="append" class="icon iconfont icon-gou-wukuang" @click="updateInvoiceRemarks" v-if="remarkStatus"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row v-if="isReadonly">
            <el-col :span="24">
                <div class="user_info">
                    <el-form :model="userForm" inline="inline" label-position="left" label-width="200px"
                             ref="goodsForm">
                        <div class="invoice_table goods_list user_info">
                            <template v-for="(item, index) in invoiceForm.invoiceDetailTitle">
                                <el-form-item :key="index" :label="item.Title" :prop="item.FiledKey">
                                    <template>
                                        <el-input
                                                :readonly="true"
                                                placeholder=" "
                                                v-model="userForm[item.FiledKey]"></el-input>
                                    </template>
                                </el-form-item>
                            </template>
                        </div>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form :model="editForm" inline="inline" label-position="left" label-width="200px" ref="editForm">
                    <el-form-item :label="invoiceForm.remark.Title" :prop="invoiceForm.remark.FiledKey"
                                  class="invoice_remark"
                                  label-width="70px" v-if="!isReadonly">
                        <el-input placeholder=" " v-model="editForm[invoiceForm.remark.FiledKey]"></el-input>
                    </el-form-item>
                    <div class="invoice_table">
                        <template v-for="(item, index) in invoiceForm.formMap">
                            <el-form-item :key="index" :label="item.Title" :prop="item.FiledKey">
                                <template v-if="item.DataType === '2'">
                                    <el-input-number
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :controls="false" :min="1" :readonly="isReadonly"
                                            :step-strictly="true"
                                            placeholder=" "
                                            v-model="editForm[item.FiledKey]"></el-input-number>
                                </template>
                                <template v-else-if="item.DataType === '3'">
                                    <el-input-number
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :controls="false" :min="0" :precision="2"
                                            :readonly="isReadonly"
                                            placeholder=" "
                                            v-model="editForm[item.FiledKey]"></el-input-number>
                                </template>
                                <template v-else-if="item.DataType === '4'">
                                    <el-input-number
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :controls="false" :min="0" :precision="8"
                                            :readonly="isReadonly"
                                            placeholder=" "
                                            v-model="editForm[item.FiledKey]"></el-input-number>
                                </template>
                                <template v-else-if="item.DataType === '5'">
                                    <el-date-picker
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :clearable="false"
                                            :readonly="isReadonly"
                                            placeholder=" "
                                            type="date"
                                            v-model="editForm[item.FiledKey]"
                                            value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </template>
                                <template v-else-if="item.DataType === '6'">
                                    <el-date-picker
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :clearable="false"
                                            type="datetime"
                                            :readonly="isReadonly"
                                            placeholder=" "
                                            v-model="editForm[item.FiledKey]"
                                            value-format="yyyy-MM-dd HH:mm">
                                    </el-date-picker>
                                </template>
                                <template v-else-if="item.DataType === '7'">
                                    <el-date-picker
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"

                                            :clearable="false"
                                            :readonly="isReadonly"
                                            format="yyyy-MM-dd HH:mm"
                                            placeholder=" "
                                            type="datetime"
                                            v-model="editForm[item.FiledKey]"
                                            value-format="yyyy-MM-dd HH:mm">
                                    </el-date-picker>
                                </template>
                                <template v-else>
                                    <el-input
                                            :class="{'changed': invoiceForm.changeFields.indexOf(item.FiledKey) !== -1}"
                                            :readonly="isReadonly"
                                            placeholder=" "
                                            v-model="editForm[item.FiledKey]"></el-input>
                                    <el-tooltip :content="invoiceForm.errorFields.filter(x=>x.Field==item.FiledKey).length>0?invoiceForm.errorFields.filter(x=>x.Field==item.FiledKey)[0].ErrorMessage:''" class="item"
                                                effect="dark" placement="top">
                                        <div class="err"
                                             v-if="invoiceForm.errorFields.filter(x=>x.Field==item.FiledKey).length>0"></div>
                                    </el-tooltip>
                                </template>
                            </el-form-item>
                        </template>
                    </div>
                </el-form>
            </el-col>
            <el-col :span="12">
                <div class="invoice_attachment" :class="isReadonly ? '' : 'mt45'"
                     v-if="invoiceForm.fileInfo.FileUrl">
                    <div class="invoice_attachment_title">{{$t('message.Attachment')}}</div>
                    <div class="invoice_attachment_content">
                        <div style="margin-bottom: 17px">
                            <el-tooltip
                                    :content="$t('message.OpenInNew')"
                                    class="item"
                                    effect="dark"
                                    placement="top"
                            >
                                <el-button
                                        @click="goToFull"
                                        class="iconfont icon-fangda"
                                        type="primary"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip
                                    :content="$t('message.DownloadFile')"
                                    class="item"
                                    effect="dark"
                                    placement="top"
                            >
                                <el-button
                                        @click="goToDownload"
                                        class="iconfont icon-xiazai-kong1"
                                        type="primary"
                                ></el-button>
                            </el-tooltip>
                            <el-tooltip
                                    :content="$t('message.Spin')"
                                    class="item"
                                    effect="dark"
                                    placement="top"
                            >
                                <el-button
                                        @click="spinAttach"
                                        class="iconfont icon-shuaxin"
                                        v-if="invoiceForm.fileInfo.FileType.toLocaleLowerCase() === '.pdf'"
                                ></el-button>
                            </el-tooltip>
                        </div>
                        <div :style="{height: ((invoiceForm.formMap.length * 41) - 115) > 485 ? ((invoiceForm.formMap.length * 41) - 115)  + 'px' : 485 + 'px', lineHeight: (invoiceForm.formMap.length * 41) - 115 + 'px', marginBottom: ((invoiceForm.formMap.length * 41) - 115) > 485 ? 14  + 'px' : 0 + 'px'}"
                             @mouseout="setOverflow('1')" @mouseover="setOverflow('0')" class="invoice_attachment_box">
                            <iframe :src="invoiceForm.fileInfo.PDFUrl"
                                    class="pdf" ref="attachment"
                                    v-if="invoiceForm.fileInfo.FileType.toLocaleLowerCase() === '.pdf'"></iframe>
                            <iframe :src="imgPath + '?file=' + encodeURIComponent(invoiceForm.fileInfo.FileUrl)"
                                    class="img" id="imgIframe" v-else></iframe>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="goods_lists">
                    <goods-edit :invoiceItemForm="item" :isReset="isReset" :isSubmit="isSubmit"
                                :key="index" @getItemData="getItemData"
                                v-for="(item, index) in invoiceForm.invoiceItem"></goods-edit>
                </div>
            </el-col>
        </el-row>
                <div class="invoice_form_button" v-if="!isReadonly">
                    <el-tooltip :content="$t('message.Submit')" class="item" effect="dark" placement="top">
                        <el-button @click="submitForm" class="icon iconfont icon-gou-wukuang"
                                type="primary"></el-button>
                    </el-tooltip>
                    <el-tooltip :content="$t('message.Reset')" class="item" effect="dark" placement="top">
                        <el-button @click="resetForm"
                                class="icon iconfont icon-zhongzhi"></el-button>
                    </el-tooltip>
                </div>
        
        <el-dialog
                :title="$t('message.InsteadReason')"
                :visible.sync="dialogVisible"
                class="new_dialog"
                width="400px">
            <el-form :model="notReasonForm" :rules="notReasonFormRules" class="reason_form" label-width="0"
                     ref="notReasonForm" v-if="dialogVisible">
                <el-form-item class="reason_radio" label=" " prop="CheckedType">
                    <el-radio-group v-model="notReasonForm.CheckedType">
                        <el-radio :key="index" :label="reason.Reason" v-for="(reason, index) in reasonList">
                            {{reason.Reason}}
                        </el-radio>
                        <br>
                        <el-radio :label="0">{{$t('message.Lang_Comsump_Other')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="reason_textarea" label=" " label-width="50px"
                              prop="NotPersonalRemarks" v-if="notReasonForm.CheckedType === 0">
                    <el-input :placeholder="$t('message.EnterInsteadReason')" type="textarea"
                              v-model="notReasonForm.NotPersonalRemarks"></el-input>
                </el-form-item>
            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-tooltip :content="$t('message.Cancel')" class="item" effect="dark" placement="top">
                    <el-button @click="dialogVisible = false" class="iconfont icon-guanbi-wukuang"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('message.Submit')" class="item" effect="dark" placement="top">
                    <el-button @click="gotoSubmit('notReasonForm')" class="iconfont icon-gou-wukuang"
                               type="primary"></el-button>
                </el-tooltip>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        GetInvoiceDetail,
        GetRealNameReasonCode,
        UpdateInvoiceRemarks,
        UpdateInvoiceDetail
    } from "../api/apiInvoice";
    import {setStore, getStore, getLocal,removeStore} from "../config/mUtils";
    import {pdfPath, imgPath} from "../config/env";
    import goodsEdit from "../components/goodsEdit";

    export default {
        name: "invoiceEdit",
        props: ['invoiceData', 'curItem', 'remarkStatus'],
        components: {goodsEdit},
        data() {
            return {
                pdfPath,
                imgPath,
                userForm: {},
                editForm: {},
                invoiceForm: this.invoiceData,
                rotateTimes: 0,
                isSubmit: false,
                saveItemData: [],
                curFiledKey: '',
                isReset: '',
                naturalWidth: 0,
                naturalHeight: 0,
                isReadonly: false,
                dialogVisible: false,
                reasonList: [],
                notReasonForm: {
                    CheckedType: '',
                    NotPersonalRemarks: ''
                },
                notReasonFormRules: {
                    NotPersonalRemarks: [
                        {required: true, message: this.$t('message.EnterInsteadReason'), trigger: 'blur'}
                    ]
                },
                initialMainData: {},
                isMainChanged: false,
                showRemark: false,
                remarkLabel: ''
            }
        },
        created() {
            if (this.$route.query.Id || this.$route.query.InvoiceKey) {
                this.initForm();
            } else {
                this.getInvoiceDetail(this.invoiceData.Id);
            }
            if (this.$route.name === 'myInvoiceDetail') {
                if (this.$route.query.IsEdit) {
                    this.isReadonly = true;
                } else {
                    this.isReadonly = false;
                }
            } else {
                this.isReadonly = true;
            }
        },
        mounted() {
            let dom = document.getElementById('main');
            dom.style.overflowY = 'auto';
        },
        methods: {
            // 返回首页
            goBack() {
                removeStore('changedInvoiceIndexData');
                this.$router.push('/myInvoice');
            },
            //获取发票明细跳转详情
            getInvoice(id) {
                return new Promise(async (resolve) => {
                    let data = await GetInvoiceDetail(
                        id,
                        getLocal('language')
                    );
                    resolve(data)
                })
            },
            // 获取发票明细
            async getInvoiceDetail(Id) {
                try {
                    let data = await GetInvoiceDetail(
                        Id,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.invoiceForm = {
                            remark: data.data.invoiceRemarks,
                            formMap: data.data.main,
                            fileInfo: data.data.fileInfo,
                            changeItems: data.data.changeItems,
                            invoiceItem: data.data.invoiceItem,
                            changeFields: data.data.changeFields,
                            errorFields: data.data.errorFieldsNew,
                            typeDesc: data.data.typeDesc,
                            invoiceDetailTitle: data.data.invoiceDetailTitle
                        };
                        console.log(this.invoiceForm,'//////////////////')
                        if (data.data.fileInfo.FileType.toLocaleLowerCase() === '.pdf') {
                            this.invoiceForm.fileInfo.PDFUrl = pdfPath + '?file=' + encodeURIComponent(data.data.fileInfo.FileUrl);
                        }
                        this.$set(this.editForm, this.invoiceForm.remark.FiledKey, this.invoiceForm.remark.Value);
                        this.invoiceForm.formMap.forEach(ele => {
                            this.$set(this.editForm, ele.FiledKey, ele.Value);
                        });
                        data.data.invoiceDetailTitle.forEach(ele => {
                            this.$set(this.userForm, ele.FiledKey, ele.Value);
                        });
                        this.initialMainData = JSON.stringify(this.editForm);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 赋值
            initForm() {
                this.editForm = {};
                if (this.invoiceForm) {
                    this.$set(this.editForm, this.invoiceForm.remark.FiledKey, this.invoiceForm.remark.Value);
                    this.invoiceForm.formMap.forEach(ele => {
                        this.$set(this.editForm, ele.FiledKey, ele.Value);
                    });
                    this.invoiceForm.invoiceDetailTitle.forEach(ele => {
                        this.$set(this.userForm, ele.FiledKey, ele.Value);
                    });
                }
                this.initialMainData = JSON.stringify(this.editForm);
                this.showRemark = true;
                this.remarkLabel = this.invoiceForm.remark.Title;
            },
            //下载附件
            goToDownload(){
                console.log(this.invoiceData)
                window.open(this.invoiceData.fileInfo.FileUrl)
            },
            // 查看大图
            async goToFull() {
                const res = await this.getInvoice(this.invoiceData.Id)
                console.log(res)
                if (res.error_code === '0') {
                    if (res.data.fileInfo.FileType.toLocaleLowerCase() === '.pdf') {
                        window.open(pdfPath + '?file=' + encodeURIComponent(res.data.fileInfo.FileUrl));
                    } else {
                        window.open(imgPath + '?file=' + encodeURIComponent(res.data.fileInfo.FileUrl));
                    }
                }
            },
            // 旋转
            spinAttach() {
                this.rotateTimes += 1;
                this.$refs.attachment.style.transform = 'rotate(' + (90 * this.rotateTimes) + 'deg)';
                let times = this.rotateTimes % 4;
                if (times % 2 === 1) {
                    this.$refs.attachment.style.left = (this.naturalHeight - this.naturalWidth) / 2 + 'px';
                    this.$refs.attachment.style.top = (this.naturalWidth - this.naturalHeight) / 2 + 'px';
                } else {
                    this.$refs.attachment.style.left = 0 + 'px';
                    this.$refs.attachment.style.top = 0 + 'px';
                }
            },
            // 获取原因列表
            async getRealNameReasonCode() {
                try {
                    let data = await GetRealNameReasonCode();
                    if (data.error_code === '0') {
                        this.reasonList = data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 提交
            submitForm() {
                this.isMainChanged = false;
                this.isSubmit = new Date().toLocaleString();
                let initialMainData = JSON.parse(this.initialMainData);
                let keyLists = Object.keys(initialMainData);
                keyLists.forEach(ele => {
                    if (initialMainData[ele].toString() !== this.editForm[ele].toString()) {
                        if (ele !== 'TotalAmount' && ele !== 'InvoiceRemarks') {
                            this.isMainChanged = true;
                            return false;
                        } else {
                            if (ele === 'TotalAmount' && parseFloat(initialMainData[ele]).toFixed(2) !== parseFloat(this.editForm[ele]).toFixed(2))
                                this.isMainChanged = true;
                            return false;
                        }
                    }
                })
                setTimeout(() => {
                    if (initialMainData.InvoiceRemarks !== this.editForm.InvoiceRemarks) {
                        this.updateInvoiceRemarks();
                    }
                    this.updateInvoiceDetail(JSON.stringify(this.saveItemData));
                }, 200);
            },
            // 重置
            resetForm() {
                this.isReset = new Date().toLocaleString();
                setTimeout(() => {
                    this.getInvoiceDetail(this.$route.query.Id ? this.$route.query.Id : this.invoiceData.Id);
                }, 200);
            },
            // 获取商品内容
            getItemData(val) {
                this.saveItemData.push(JSON.parse(val));
            },
            // 更新发票备注
            async updateInvoiceRemarks() {
                try {
                    let data = await UpdateInvoiceRemarks(
                        this.invoiceData.Id,
                        this.editForm[this.invoiceForm.remark.FiledKey]
                    );
                    if (data.error_code === '0') {
                        let OCRData = JSON.parse(getStore('OCRData'));
                        if (this.$route.query.Id) {
                            let changeData = {
                                InvoiceRemarks: data.data,
                                InvoiceNumber: this.editForm['InvoiceNumber'],
                                TypeDesc: this.editForm['TypeDesc'],
                                TotalAmount: this.editForm['TypeDesc']
                            }
                            this.$emit('getChangeData', changeData);
                            if (this.showRemark) {
                                //this.$message.success(this.$t('message.ModifySuccessfully'));
                            }
                        } else {
                            OCRData[this.curItem].InvoiceRemarks.Value = data.data;
                            setStore('OCRData', OCRData);
                            let changeData = {
                                InvoiceRemarks: data.data,
                                InvoiceNumber: OCRData[this.curItem].InvoiceNumber.Value,
                                TypeDesc: OCRData[this.curItem].TypeDesc.Value,
                                TotalAmount: OCRData[this.curItem].TotalAmount.Value
                            }
                            this.$emit('getChangeData', changeData);
                        }
                    } else {
                        this.$message.error(data.error_code);
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 编辑数据/确定提交
            async updateInvoiceDetail(invoiceItem) {
                try {
                    let data = await UpdateInvoiceDetail(
                        this.invoiceData.Id,
                        this.isMainChanged ? JSON.stringify(this.editForm) : '',
                        invoiceItem,
                        getLocal('language'),
                        getLocal('ADAccount'),
                        this.notReasonForm.NotPersonalRemarks
                    );
                    if (data.error_code === '0') {
                        this.saveItemData = [];
                        this.$message.success(this.$t('message.ModifySuccessfully'));
                        this.getInvoiceDetail(this.invoiceData.Id);
                        this.dialogVisible = false;
                        if (this.$route.query.Id) {
                            let changeData = {
                                InvoiceRemarks: this.editForm['InvoiceRemarks'],
                                InvoiceNumber: this.editForm['InvoiceNumber'],
                                TypeDesc: this.editForm['TypeDesc'],
                                TotalAmount: this.editForm['TypeDesc']
                            }
                            this.$emit('getChangeData', changeData);
                            this.$router.push('/myInvoice');
                        } else {
                            let OCRData = JSON.parse(getStore('OCRData'));
                            OCRData[this.curItem].InvoiceNumber.Value = this.editForm['InvoiceNumber'];
                            OCRData[this.curItem].TypeDesc.Value = this.editForm['TypeDesc'];
                            OCRData[this.curItem].TotalAmount.Value = this.editForm['TotalAmount'];
                            setStore('OCRData', OCRData);
                            let changeData = {
                                InvoiceRemarks: OCRData[this.curItem].InvoiceRemarks.Value,
                                InvoiceNumber: this.editForm['InvoiceNumber'],
                                TypeDesc: this.editForm['TypeDesc'],
                                TotalAmount: this.editForm['TypeDesc']
                            }
                            this.$emit('getChangeData', changeData);
                            if (OCRData.length === 1) {
                                this.$router.push('/myInvoice');
                            }
                        }
                    } else if (data.error_code === '100005') {
                        this.getRealNameReasonCode();
                        this.notReasonForm.CheckedType = '';
                        this.notReasonForm.NotPersonalRemarks = '';
                        this.dialogVisible = true;
                    } else {
                        this.saveItemData = [];
                        this.$message.error(data.message);
                    }
                } catch (error) {
                    this.saveItemData = [];
                    console.log(error);
                }
            },
            // 设置页面的滚动条
            setOverflow(val) {
                let dom = document.getElementById('main');
                if (this.invoiceForm.fileInfo.FileType.toLocaleLowerCase() !== '.pdf') {
                    if (val === '0') {
                        dom.style.overflowY = 'hidden';
                    } else {
                        dom.style.overflowY = 'auto';
                    }
                }
            },
            // 提交原因
            gotoSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.notReasonForm.CheckedType !== '') {
                            if (this.notReasonForm.CheckedType !== 0) {
                                this.notReasonForm.NotPersonalRemarks = this.notReasonForm.CheckedType;
                            }
                            setTimeout(() => {
                                this.updateInvoiceDetail(JSON.stringify(this.saveItemData));
                            }, 200);
                        } else {
                            this.$message.warning(this.$t('message.PleaseChoseType'));
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
